import { IAppState } from '@zet/utils/interface'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

const useAuthStore = create<IAppState>(
  subscribeWithSelector((set) => ({
    isAuthenticated: false,
    authToken: '',
    setIsAuthenticated: (payload) =>
      set((state) => ({ ...state, isAuthenticated: payload })),
    setAuthToken: (payload) =>
      set((state) => ({ ...state, authToken: payload })),
    unauthorizedApiError: false,
    setUnauthorizedApiError: (payload) =>
      set((state) => ({ ...state, unauthorizedApiError: payload })),
  }))
)

export default useAuthStore
